const TipoItem = {
    PlanInternet: "planInt",
    ServicesGen: "servGen",
    Articulo: "art",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
};

const EstadoContrato = {
    Abierto: "abier",
    Revisado: "rev",
    Cerrado: "cerr",
};

const cicloFact = {
    quinceDeMes: "15m",
    ultimoDiaMes: "ultdm",
};

const TipoComp = {
    Recibo: "rec",
    Boleta: "bol",
    Factura: "fact",
};

export {EstadoContrato, cicloFact, TipoComp, TipoItem, Udm, Moneda };
